import { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';

const ROLE_LABELS = {
  admin:    'Admin',
  staff:    'Staff',
  customer: 'Customer',
  supplier: 'Supplier',
  reseller: 'Reseller',
};

const ROLE_STYLES = {
  admin:    'bg-[#F5F3FF] text-[#5B21B6]',
  staff:    'bg-blue-light text-pb',
  customer: 'bg-green-light text-[#065F46]',
  supplier: 'bg-[#CCFBF1] text-[#0F766E]',
  reseller: 'bg-amber-light text-[#92400E]',
};

export default function UserSettings() {
  const { currentUser, userRole } = useAuth();
  const [resetSent, setResetSent] = useState(false);
  const [resetting, setResetting] = useState(false);

  async function sendReset() {
    if (!currentUser?.email) return;
    setResetting(true);
    try {
      await sendPasswordResetEmail(auth, currentUser.email);
      setResetSent(true);
    } finally {
      setResetting(false);
    }
  }

  return (
    <>
      <div className="mb-6">
        <h2 className="text-[20px] font-bold text-[#111827]">User Settings</h2>
        <p className="text-[13px] text-[#6B7280] mt-1">Your account details.</p>
      </div>

      <div className="max-w-lg space-y-5">
        <div className="bg-white rounded-[12px] border border-[#E5E7EB] p-6 space-y-5">
          <h3 className="text-[11px] font-semibold text-[#9CA3AF] uppercase tracking-[0.9px]">Account</h3>

          <div>
            <p className="text-[11px] font-semibold text-[#9CA3AF] uppercase tracking-[0.9px] mb-1">Email</p>
            <p className="text-[14px] text-[#111827]">{currentUser?.email || '—'}</p>
          </div>

          <div>
            <p className="text-[11px] font-semibold text-[#9CA3AF] uppercase tracking-[0.9px] mb-1">Role</p>
            <span className={`text-[11px] font-semibold px-[9px] py-[3px] rounded-[12px] ${ROLE_STYLES[userRole] || 'bg-[#F3F4F6] text-[#6B7280]'}`}>
              {ROLE_LABELS[userRole] || userRole || '—'}
            </span>
          </div>
        </div>

        <div className="bg-white rounded-[12px] border border-[#E5E7EB] p-6 space-y-4">
          <h3 className="text-[11px] font-semibold text-[#9CA3AF] uppercase tracking-[0.9px]">Password</h3>
          <p className="text-[13px] text-[#6B7280]">
            We'll send a password reset link to <strong className="text-[#374151]">{currentUser?.email}</strong>.
          </p>

          {resetSent ? (
            <div className="bg-green-light border border-sg/25 text-sg rounded-[8px] px-4 py-3 text-[13px]">
              Reset link sent — check your inbox.
            </div>
          ) : (
            <button
              onClick={sendReset}
              disabled={resetting}
              className="px-[18px] py-[9px] text-[13px] font-semibold text-white bg-pb hover:bg-navy rounded-[8px] transition disabled:opacity-60"
            >
              {resetting ? 'Sending…' : 'Send password reset link'}
            </button>
          )}
        </div>
      </div>
    </>
  );
}
